<template>
  <div>
    <div>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key">{{ $t("RAM.ALI.database.stateName") }}</span>
          <span class="expand-value">{{ row.stateName }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key">{{
            $t("RAM.ALI.database.databaseCreatedTime")
          }}</span>
          <span class="expand-value">{{ row.databaseCreatedTime }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.database.maintenance") }}
          </span>
          <span class="expand-value">{{ row.maintenance }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key"
          >{{ $t("RAM.ALI.database.version") }}
          </span>
          <span class="expand-value">{{ row.version }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key"
          >{{ $t("RAM.ALI.database.nodeNumber") }}
          </span>
          <span class="expand-value">{{ row.nodeNumber }}</span>
        </Col>
      </Row>
      <Row class="expand-row"> </Row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      subnetData: this.row.resourceSubnetList,
    };
  },
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/rds/TableExpand.vue